var map = {
	"./PTMPAY/index.ts": 39386,
	"./QPay/index.ts": 34258,
	"./appQr/index.ts": 2259,
	"./cardafrica/index.ts": 27325,
	"./customInrQr/index.ts": 57778,
	"./customPay/index.ts": 72248,
	"./easypay/index.ts": 79655,
	"./idnqris/index.ts": 74285,
	"./indiaH5/index.ts": 41271,
	"./indiaH5Pay/index.ts": 75283,
	"./indiaQr/index.ts": 81671,
	"./indiaSpecial/index.ts": 58911,
	"./inrqrAnother/index.ts": 34982,
	"./jazzpay/index.ts": 12022,
	"./kaazPay/index.ts": 93788,
	"./kaazrmqr/index.ts": 97812,
	"./metaPay/index.ts": 50314,
	"./mpesa/index.ts": 29171,
	"./newIndiaQr/index.ts": 9687,
	"./newKaazPay/index.ts": 91212,
	"./neworbitpay/index.ts": 44895,
	"./newrmqr/index.ts": 16743,
	"./notSkipUpi/index.ts": 26515,
	"./orbitPay/index.ts": 76943,
	"./otherInrQr/index.ts": 98575,
	"./pkrpay/index.ts": 61852,
	"./pnbPay/index.ts": 87399,
	"./razer/index.ts": 84553,
	"./rmduitnow/index.ts": 51666,
	"./rmqr/index.ts": 67287,
	"./usdtbuy/index.ts": 13503,
	"./usdth5/index.ts": 33166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16315;